// 1–2 posters/flyers in the top-right of a page: always the whole image (never cropped), side by side when there are two.
import { useState } from "react";
import { abs } from "./vbShared";
import { PhotoLightbox } from "./PhotoGrid";

export const PosterImg = ({ p, i, count, onOpen, testid, maxH = "26rem" }) => (
  <button type="button" onClick={() => onOpen?.(i)} className="min-w-0 flex justify-center lg:justify-end cursor-zoom-in group" style={{ flex: `0 1 ${count > 1 ? "50%" : "100%"}` }} aria-label={`Open poster ${i + 1}`} data-testid={`${testid}-${i}`}>
    <img src={abs(p.url)} alt={`Poster ${i + 1}`} loading="lazy" style={{ maxHeight: maxH }}
      className="block max-w-full w-auto h-auto object-contain border-[5px] sm:border-[7px] border-white shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] transition-transform duration-300 group-hover:-translate-y-1" />
  </button>
);

export const PosterFrame = ({ posters = [], className = "", maxH = "26rem", testid = "poster-frame" }) => {
  const [zoom, setZoom] = useState(null);
  const list = (posters || []).filter((p) => p?.url).slice(0, 2);
  if (!list.length) return null;
  return (
    <div className={`flex items-start justify-center lg:justify-end gap-3 sm:gap-4 ${className}`} data-testid={testid} data-count={list.length}>
      {list.map((p, i) => <PosterImg key={p.poster_id || p.url} p={p} i={i} count={list.length} onOpen={setZoom} testid={testid} maxH={maxH} />)}
      {zoom != null && <PhotoLightbox photos={list} index={zoom} onClose={() => setZoom(null)} />}
    </div>
  );
};
